const ProgressBar = ({progress}) => {
    return (
        <div className='w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-100'>
            <div className='bg-yellow-500 h-2.5 rounded-full motion-safe:transition-[width] motion-safe:duration-500 motion-safe:ease-out' style={{width: progress + '%'}}></div>
        </div>
    )
}

export default ProgressBar;